/* eslint-disable @typescript-eslint/no-useless-constructor */
import { CanvasType, SocketType } from "../types/storeType";
import Tool from "./Tool";

export default class Line extends Tool {
    mouseDown: boolean = false;
    currentX: number = 0;
    currentY: number = 0;
    saved: string | undefined;

    constructor(canvas: CanvasType, socket: SocketType, id: string) {
        super(canvas, socket, id);
        this.listen();
    }

    listen() {
        this.canvas!.onpointerdown = this.mouseDownHandler.bind(this);
        this.canvas!.onpointerup = this.mouseUpHandler.bind(this);
        this.canvas!.onpointermove = this.mouseMoveHandler.bind(this);
    }

    mouseUpHandler(e: MouseEvent) {
        this.mouseDown = false;
    }

    mouseDownHandler(e: MouseEvent) {
        this.mouseDown = true;
        this.currentX= e.pageX - this.canvas!.offsetLeft;
        this.currentY = e.pageY - this.canvas!.offsetTop;
        this.ctx?.beginPath();
        this.ctx?.moveTo(this.currentX, this.currentY)
        this.saved = this.canvas?.toDataURL()
    }

    mouseMoveHandler(e: MouseEvent) {
        if(this.mouseDown) {
            this.draw(e.pageX - this.canvas!.offsetLeft, e.pageY - this.canvas!.offsetTop)
        }
    }

    draw(x: number, y: number) {
        const img = new Image();
        img.src = this.saved!;
        img.onload = () => {
            this.ctx?.clearRect(0, 0, this.canvas?.width!, this.canvas?.height!);
            this.ctx?.drawImage(img, 0, 0, this.canvas?.width!, this.canvas?.height!);
            this.ctx?.beginPath()
            this.ctx?.moveTo(this.currentX, this.currentY);
            this.ctx?.lineTo(x, y);

            this.ctx?.stroke()
        }
    }
}